import { render } from "./DirectorioMemberStreamlined.vue?vue&type=template&id=ce04fa64&scoped=true"
import script from "./DirectorioMemberStreamlined.vue?vue&type=script&lang=ts"
export * from "./DirectorioMemberStreamlined.vue?vue&type=script&lang=ts"

import "./DirectorioMemberStreamlined.vue?vue&type=style&index=0&id=ce04fa64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce04fa64"

export default script